var AsyncBindingBehavior = /** @class */ (function () {
    function AsyncBindingBehavior() {
    }
    AsyncBindingBehavior.prototype.bind = function (binding, source, busymessage) {
        binding.originalupdateTarget = binding.updateTarget;
        binding.updateTarget = function (a) {
            if (typeof a.then === "function") {
                if (busymessage) {
                    binding.originalupdateTarget(busymessage);
                }
                a.then(function (d) {
                    if (binding.originalupdateTarget && typeof binding.originalupdateTarget == "function") {
                        binding.originalupdateTarget(d);
                    }
                });
            }
            else {
                if (binding.originalupdateTarget && typeof binding.originalupdateTarget == "function") {
                    binding.originalupdateTarget(a);
                }
            }
        };
    };
    AsyncBindingBehavior.prototype.unbind = function (binding) {
        binding.updateTarget = binding.originalupdateTarget;
        binding.originalupdateTarget = null;
    };
    return AsyncBindingBehavior;
}());
export { AsyncBindingBehavior };
